import React from "react";
import NavigateButtons from "components/NavigateButtons";

export default function Step3Intro({ currentStep, setCurrentStep, setFieldValue, setIsVisibleStep3Intro }) {
   const handleCetatenie = value => {
      setFieldValue("tipCetatenie", value);
      setIsVisibleStep3Intro(false);
   };
   return (
      <div className="pas-3-intro">
         <h2>Pentru continuarea procesului de contractare, te rugăm să selectezi cetățenia ta din opțiunile de mai jos</h2>
         <div className="row cetatenie-butoane-row">
            <div className="col-md-6">
               <button onClick={() => handleCetatenie("ROMAN")} className="button-cetatean-roman w-100">
                  Cetățean Român
               </button>
            </div>
            <div className="col-md-6">
               <button onClick={() => handleCetatenie("STRAIN")} className="button-cetatean-strain w-100">
                  Cetățean Strain
               </button>
            </div>
         </div>
         <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} next={"displayNone"} />
      </div>
   );
}
